import React, { useState } from 'react';
import { Card, Form, Row, Col, Input, InputNumber, Switch, Select, Space } from 'antd';
import { Company } from '../../../../types/company.types';
import { Option } from '../../../../core/common/commonSelect';

interface ExtraInfoFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  companyData: Partial<Company>;
  loading: boolean;
}
const shiftModeOptions: Option[] = [
    { value: 'fixed', label: 'Sabit' },
    { value: 'assignment', label: 'Vardiyalı' },
    { value: 'both', label: 'Hem Sabit Hem Vardiya' }
  ];

const ExtraInfoForm: React.FC<ExtraInfoFormProps> = ({ form, companyData, loading }) => {
  const [shiftMode, setShiftMode] = useState<string>('');

  const handleShiftModeChange = (value: string) => {
    setShiftMode(value);
  };

  return (
  <Card className="setting-card" title="Ek Bilgiler">
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Şehir"
          name="city"
          initialValue={companyData.city}
        >
          <Input size="large" placeholder="Şehir giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Posta Kodu"
          name="zipCode"
          initialValue={companyData.zipCode}
        >
          <Input size="large" placeholder="Posta kodu giriniz" disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="Yıllık İzin Süresi"
          name="annualLeaveLimit"
          initialValue={companyData.settings?.annualLeaveLimit ?? 23}
          rules={[{ required: true, message: 'İzin süresi zorunludur' }]}
        >
          <InputNumber
            size="large"
            style={{ width: '100%' }}
            min={0}
            max={365}
            placeholder="İzin süresini giriniz"
            disabled={loading}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          label="IP Kontrol"
          name="ipControl"
          valuePropName="checked"
          initialValue={companyData.settings?.ipControl ?? false}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Card className="setting-card shift-type-card">
            <Form.Item
            label={
                <Space>
                 Şirket Çalışma Modu
                </Space>
            }
            name="shiftMode"
            rules={[{ required: true, message: 'Şirket çalışma modu zorunludur' }]}
            >
            <Select
                value={shiftMode}
                options={shiftModeOptions}
                onChange={handleShiftModeChange}
            />
            </Form.Item>
        </Card>
        </Col>
    </Row>
  </Card>
)};

export default ExtraInfoForm;
